import { SVGProps, Ref, forwardRef } from 'react';

export const FunnelFilledSize24Glyph = forwardRef((props: SVGProps<SVGSVGElement>, ref: Ref<SVGSVGElement>) => (
    <svg width={24} height={24} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" ref={ref} {...props}>
        <g>
            <path d="m15 16 8-11V2H1v3l8 11v6h6z" fill="currentColor" />
        </g>
    </svg>
));
FunnelFilledSize24Glyph.displayName = 'FunnelFilledSize24Glyph';
